/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import store from '@/store/index';
import * as api from '@/api/play';
import { PLAY } from '@/store/types';
import { PlayOrder } from '@/api/types/play';

export interface StorePlayOrderDetailState {
  id: number;
  time: number;
  order: PlayOrder;
}

export default {
  namespaced: true,
  state: {
    id: null,
    time: null,
    order: null,
  },
  getters: {},
  actions: {
    [PLAY.GET_ORDER]({ state, commit }, { id, reload, refresh, fetch }) {
      if (refresh ? state.id === id : state.id !== id) {
        reload = true;
      }
      if (!id) {
        commit(PLAY.GET_ORDER, { status: 'clear' });
      } else if (reload || fetch) {
        commit(PLAY.GET_ORDER, { status: 'start', id });
        return new Promise((resolve, reject) => {
          api.getOrder(id).then((res) => {
            commit(PLAY.GET_ORDER, {
              status: 'success',
              id,
              data: res.data,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [PLAY.GET_ORDER](state, { status, id, data }) {
      if (status === 'clear') {
        state.id = null;
        state.order = null;
        state.time = null;
      } else if (status === 'start') {
        state.id = id;
      } else if (status === 'success') {
        if (state.id === id) {
          state.id = id;
          state.order = data;
          state.time = new Date().valueOf();
        }
        store.commit(`play/order/list/${PLAY.UPDATE_ORDER}`, { id, order: data });
      }
    },
    [PLAY.UPDATE_ORDER](state, { id, order = null }) {
      if (state.id === id) {
        state.order = order;
      }
    },
  },
};
